import { FC, useMemo } from 'react';
// Mui
import { 
  SxProps, Theme,
  Box, Typography
} from '@mui/material';

export type IconVariants =
  // Chat
  | 'chat_automated' | 'chat_shared_by_me' | 'chat_shared_with_me' | 'chat-private' | 'new_chat' | 'send_to_ai_chat'
  // Actions
  | 'save_alt' | 'add' | 'add_to_workspace' | 'delete' | 'edit' | 'done' | 'close' | 'remove_from_workspace'
  // Navigation
  | 'arrow_drop_down' | 'arrow_upward' | 'chevron_left' | 'chevron_right' | 'swap_horiz' | 'go_to_last_opened' | 'go_to_post_event'
  // Layout/Columns
  | 'columns_2' | 'columns_3' | 'columns_4' | 'columns_auto' | 'pages_view' | 'episodes_view'
  // Media/Playback
  | 'play_circle_outline_outlined' | 'play-custom'
  // Misc
  | 'additional' | 'batch' | 'billing' | 'case_number' | 'color' | 'compare' | 'Divider' | 'event'
  | 'headset_mic' | 'highlight' | 'load_data_to_daily_chart' | 'more_vert' | 'notes' | 'notifications_none'
  | 'preview' | 'rotate_right' | 'select_all' | 'staple_delete' | 'staple_edit' | 'stapled' | 'team' | 'shared'
  | 'client' | 'rotate_right_outlined' | 'color_assign' | 'tag_assign' | 'sort-amount-desc'
  // Rotation
  | 'rotate_clockwise_90' | 'rotate_clockwise_180' | 'rotate_clockwise_270'
  // SVG
  | 'svgviewer-output-2'
;

export type IconProps = {
  icon: IconVariants;
  label?: string;
  size?: 'small' | 'default';
  rootSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
};

const Icon:FC<IconProps> = ({
  // Props
  icon, size = 'default', label = '', rootSx = {}, sx = {}
}) => {
  const sizing = size === 'default' ? '24px' : '16px';
  const defaultRootSx = useMemo(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 2
  }), []);
  const defaultSx = useMemo(() => ({
    width: sizing,
    height: sizing,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: sizing
  }), [sizing]);

  return (
    <Box sx={{ ...defaultRootSx, ...rootSx }}>
      <Box sx={{ ...defaultSx, ...sx }}><i className={`icon icon-${icon}`}></i></Box>
      {label ? (
        <Typography variant="body2">{label}</Typography>
      ) : null}
    </Box>
  )
}

export default Icon;
